<template>
  <div class="block">
    <editor v-model="val" @change="change" />
    <!-- <div v-html="node.title" ref="ta" contenteditable="true" @input="change"></div> -->
    <div class="controls">
      <button @click="convertToAccordion">Convert to accordion</button>
      <button @click="deleting = true">Delete</button>
    </div>
    <ModalWindow v-if="deleting" @close="deleting = false">
      <h3 style="margin-top: 0">Are you sure?</h3>
      <div style="display: flex; justify-content: space-between">
        <button @click="deleting = false">Cancel</button>
        <button @click="deleteThis()">Yes</button>
      </div>
    </ModalWindow>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Editor from "./Editor.vue";
import ModalWindow from "./ModalWindow.vue";

export default {
  name: "Block",
  props: ["node", "parentId"],
  components: {
    Editor,
    ModalWindow,
  },
  data() {
    return {
      val: this.node.title,
      t: null,
      editor: null,
      deleting: false,
    };
  },
  watch: {
    val(val) {
      console.log("changed!");
      if (this.t) {
        clearTimeout(this.t);
        this.t = null;
      }
      this.t = setTimeout(() => {
        console.log("update");
        this.$store.commit("updateNode", { nodeId: this.node.id, html: val });
      }, 200);
    },
  },
  methods: {
    ...mapMutations(["convert", "deleteBlock"]),
    deleteThis() {
      this.deleteBlock({ blockId: this.node.id });
    },
    change(e) {
      this.val = this.$refs.ta.innerHTML;
    },
    convertToAccordion() {
      this.convert({
        to: "Accordion",
        id: this.node.id,
      });
    },
  },
};
</script>

<style lang="scss">
.block {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (min-width: 500px) {
    flex-direction: row;
  }
}
</style>
